'use strict';

import Modal from "./../utils/modal";
import Comparison from "./../utils/comparison"

const modelListModal = new Modal()
    .setTriggerSelector('.model-list-modal-trigger')
    .setModalId('model-list-modal')
    .setModalWrapperId('model-list-modal-wrapper')
    .setUpListenersContent();
modelListModal.render();

(new Comparison())
    .setUpListeners()
    .setModal(modelListModal);

$(document).on('comparison.renderContent', '#comparison-content', (e, response) => {
    modelListModal.renderContent(response);
});

$('#model-list-modal').on('shown.bs.modal', () => {
    let heightOftitle = [],
        heightOfimg = [],
        heightOftagi = [],
        heightOfCechy = [],
        heightOfSize = [];
    $('#comparison-content .row .col-sm-4.add_prod_heig_of_content').each(function () {
        heightOftitle.push($(this).find('.title').height());
        // heightOfimg.push($(this).find('.img').height());
        heightOftagi.push($(this).find('.tagi').height());
        heightOfCechy.push($(this).find('.cechy').height());
        heightOfSize.push($(this).find('.size').height());
    });
    $('#comparison-content .row .col-sm-4 .title').height(Math.max.apply(Math, heightOftitle));
    // $('#comparison-content .row .col-sm-4 .img').height(Math.max.apply(Math, heightOfimg));
    $('#comparison-content .row .col-sm-4 .tagi').height(Math.max.apply(Math, heightOftagi));
    $('#comparison-content .row .col-sm-4 .cechy').height(Math.max.apply(Math, heightOfCechy));
    $('#comparison-content .row .col-sm-4 .size').height(Math.max.apply(Math, heightOfSize));
});

$('.dropdown-menu').on('click', function (e) {
    e.stopPropagation();
});

$(".left_elem.checkbox_industi .dropdown .dropdown-menu").each(function () {
    let dropdown = $(this).parent().find('.dropdown-toggle');
    let counter = 0;
    if ($(this).hasClass('selects')) {
        $($(this).find('.form-group')).each(function () {
            let inputValue = $(this).find('select').val();
            if (inputValue) {
                dropdown.addClass('checked');
                counter++;
            }
        });
        if (counter !== 0) {
            dropdown.append(' (' + counter + ')');
        }
    } else {
        $(this).children().each(function () {
            let checkBox = $(this).find('.form-check input');
            if (checkBox.prop('checked')) {
                dropdown.addClass('checked');
                counter++;
            }
        });
        if (counter !== 0) {
            dropdown.append(' (' + counter + ')');
        }
    }
});

let filterCancelButton = $('.filter-cancel-button');
let filterFeatureCancelButton = $('.filter-feature-cancel-button');

filterCancelButton.on('click', (event) => {
    const $target = $(event.target);

    $target.parents('.dropdown-menu')
        .find('input[type=checkbox]')
        .prop('checked', false)
        .removeData('isChecked')
        .trigger('change')
        .siblings('label')
        .removeClass('active');

    const menu = $($target).closest('.dropdown-menu');
    $(menu).removeClass('show');
});

filterFeatureCancelButton.on('click', (event) => {
    const $target = $(event.target);

    $target.parents('.dropdown-menu')
        .find('.active')
        .removeClass('active');

    $target.parents('.dropdown-menu')
        .find('input[type=checkbox]')
        .prop('checked', false)
        .removeData('isChecked')
        .trigger('change')
});



// WEBPACK FOOTER //
// ./assets/js/distributor/models-filter.js